import { requestBuilder } from '../../../http/RequestBuilder';

/**
 * Queues a server-side bill refresh job for one account. Does not refetch client data.
 * Backend: POST /api/admin/memberships/:membershipId/accounts/:accountId/bills/refresh
 */
export interface RefreshBillsForAccountUrlParams {
    membershipId: string;
    accountId: string;
}

export const useRefreshBillsForAccountMutation = requestBuilder.mutation<
    unknown,
    undefined,
    RefreshBillsForAccountUrlParams
>({
    endpoint: ({ membershipId, accountId }) =>
        `/api/admin/memberships/${membershipId}/accounts/${accountId}/bills/refresh`,
    method: 'POST',
});
